import { render, staticRenderFns } from "./edittags.vue?vue&type=template&id=5fcca177&scoped=true"
import script from "./edittags.vue?vue&type=script&lang=js"
export * from "./edittags.vue?vue&type=script&lang=js"
import style0 from "./edittags.vue?vue&type=style&index=0&id=5fcca177&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcca177",
  null
  
)

export default component.exports